/**
 * @file index.js
 * @description Create all re-usable components here and export them from index so that it can be imported from @/components directly.
 * @version 0.0.1
 * Created at: 11/8/2025
 * Updated at: 11/8/2025
 */

// Shadcn components
export * from './ui/accordion';
export * from './ui/alert';
export * from './ui/alert-dialog';
export * from './ui/avatar';
export * from './ui/badge';
export * from './ui/breadcrumb';
export * from './ui/button';
export * from './ui/calendar';
export * from './ui/card';
export * from './ui/chart';
export * from './ui/checkbox';
export * from './ui/collapsible';
export * from './ui/command';
export * from './ui/dialog';
export * from './ui/drawer';
export * from './ui/dropdown-menu';
export * from './ui/empty';
export * from './ui/form';
export * from './ui/input';
export * from './ui/input-otp';
export * from './ui/item';
export * from './ui/label';
export * from './ui/popover';
export * from './ui/radio-group';
export * from './ui/scroll-area';
export * from './ui/select';
export * from './ui/separator';
export * from './ui/sheet';
export * from './ui/sidebar';
export * from './ui/skeleton';
export * from './ui/sonner';
export * from './ui/switch';
export * from './ui/table';
export * from './ui/tabs';
export * from './ui/textarea';
export * from './ui/toggle';
export * from './ui/toggle-group';
export * from './ui/tooltip';

// Other components

export * from './avatar-upload';
export * from './data-table';
export * from './data-table/data-table-column-header';
export * from './data-table/data-table-pagination';
export * from './divider';
export * from './empty';
export * from './expendable-table';
export * from './expendable-table/data-table-column-header';
export * from './expendable-table/data-table-pagination';
export * from './form-builder';
export * from './image';
export * from './loader';
export * from './multi-select';
export * from './my-tabs';
export * from './overlay';
export * from './permission-wrapper';
export * from './prompt-editor';
export * from './theme-toggle';

// Error pages
export * from './audio-player';
export * from './editor';
export * from './errors/go-back-error';

